import styled from 'styled-components'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import { OptionButton } from '~/pages/anatomyV2/libs/optionButtonStyles'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const AnatomyV2QuickExperimentStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0 16px;
  `,

  Card: styled.div`
    position: relative;
    background-color: ${ANATOMY_V2_ACCENT_COLOR};
    border-radius: 12px;
    padding: 30px 60px 30px 20px;
    margin-bottom: 24px;
  `,

  IconWrapper: styled.div`
    display: flex;
    margin-bottom: 16px;
  `,

  Illustration: styled.img`
    position: absolute;
    top: 0;
    right: 0;
    width: 220px;
    object-fit: contain;
    opacity: 0.9;
    pointer-events: none;
  `,

  Instruction: styled.p`
    position: relative;
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: ${COLORS.WHITE};
  `,

  Options: styled.div`
    margin-top: auto;
  `,

  OptionButton,
}
